import React, { useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { HeroBg, EyebrowPill } from "../components/tag/Primitives";
import { SHOP_PRODUCTS } from "../data/shop";
import { api } from "../lib/api";

export default function ShopCheckout() {
  const { slug } = useParams();
  const product = SHOP_PRODUCTS[slug];
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!product) return <Navigate to="/shop" replace />;

  const buy = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return toast.error("Please enter a valid email.");
    setSubmitting(true);
    try {
      const { data } = await api.post("/checkout", {
        product: product.productKey,
        email,
        origin_url: window.location.origin,
      });
      if (data.url) window.location.href = data.url;
      else toast.error("Could not create checkout session.");
    } catch {
      toast.error("Checkout error. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout title={`${product.name} | $19 | The Authority Gap`} path={`/shop/${slug}`}>
      <section style={{ background: "#090909", padding: "70px 32px 30px", position: "relative", overflow: "hidden", textAlign: "center" }}>
        <HeroBg />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 760, margin: "0 auto" }}>
          <div style={{ marginBottom: 20 }}><EyebrowPill>{product.type} · {product.pages} pages</EyebrowPill></div>
          <h1 className="tag-h1" style={{ marginBottom: 14 }}>{product.name}</h1>
          <p style={{ color: "#aaa", fontSize: 15, lineHeight: 1.7 }}>{product.blurb}</p>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "40px 20px 80px" }}>
        <div className="tag-audit-grid" style={{ maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 360px", gap: 24, alignItems: "start" }}>
          <div>
            <div className="tag-card" style={{ marginBottom: 10 }}>
              <h2 style={{ color: "#fff", fontSize: 16, fontWeight: 700, margin: "0 0 14px" }}>What's inside</h2>
              {product.delivers.map((d) => (
                <div key={d} style={{ display: "flex", gap: 10, alignItems: "baseline", marginBottom: 8 }}>
                  <span style={{ color: product.accent, fontWeight: 700 }}>✓</span>
                  <span style={{ color: "#bbb", fontSize: 13, lineHeight: 1.55 }}>{d}</span>
                </div>
              ))}
            </div>
            <div className="tag-card">
              <h3 style={{ color: "#fff", fontSize: 14, fontWeight: 700, margin: "0 0 8px" }}>How it works</h3>
              <ol style={{ color: "#bbb", fontSize: 13, lineHeight: 1.7, paddingLeft: 18, margin: 0 }}>
                <li>Check out securely with Stripe.</li>
                <li>The PDF is emailed to you immediately on payment confirmation.</li>
                <li>The download link is also visible on the confirmation page.</li>
              </ol>
            </div>
          </div>

          <div className="tag-card" style={{ position: "sticky", top: 80 }}>
            <div style={{ color: "#aaa", fontSize: 13, fontWeight: 600, marginBottom: 14 }}>{product.name}</div>
            <div style={{ color: "#fff", fontSize: 48, fontWeight: 700, lineHeight: 1, marginBottom: 4 }}>{product.priceLabel}</div>
            <div style={{ color: "#888", fontSize: 13, marginBottom: 18 }}>One-time. Instant PDF delivery.</div>
            <input
              data-testid="shop-email"
              type="email"
              placeholder="your@email.com"
              className="tag-input"
              style={{ marginBottom: 10 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button data-testid="shop-checkout-btn" type="button" className="btn-primary" onClick={buy} disabled={submitting} style={{ width: "100%" }}>
              {submitting ? "Redirecting…" : product.cta}
            </button>
            <p style={{ color: "#777", fontSize: 11, marginTop: 10, margin: "10px 0 0" }}>
              Looking for something else? <Link to="/shop" style={{ color: "#FF6575" }}>See all four PDFs</Link>.
            </p>
          </div>
        </div>
        <style>{`@media (max-width: 880px){ .tag-audit-grid{ grid-template-columns: 1fr !important; } }`}</style>
      </section>
    </Layout>
  );
}
